import { useShouldShowCreateTeamPromptBanner } from "./CreateTeamPromptBanner/useShouldShowCreateTeamPromptBanner";
import { CreateTeamPromptBanner } from "./CreateTeamPromptBanner/CreateTeamPromptBanner";
import { JoinedForWorkButNoTeamBanner } from "./JoinedForWorkBanner/JoinedForWorkBanner";
import { SuggestTeamBanner } from "./SuggestTeamBanner/SuggestTeamBanner";
import { useShouldShowJoinedForWorkButNoTeamBanner } from "./JoinedForWorkBanner/useShouldShowJoinedForWorkButNoTeamBanner";
import { useShouldShowSuggestTeamBanner } from "./SuggestTeamBanner/useShouldShowSuggestTeamBanner";
import { useUnpaidInvoiceBanner } from "./UnpaidInvoiceBanner/useUnpaidInvoiceBanner";

export const HeaderBanner: React.FC = () => {
  const unpaidInvoiceBanner = useUnpaidInvoiceBanner();

  const [showJoinedForWorkBanner, joinedForWorkProps] =
    useShouldShowJoinedForWorkButNoTeamBanner();
  const [showCreateTeamPromptBanner, createTeamPromptProps] =
    useShouldShowCreateTeamPromptBanner();

  const [shouldShowSuggestTeamBanner, suggestTeamProps] =
    useShouldShowSuggestTeamBanner();

  switch (unpaidInvoiceBanner.status) {
    case "show":
      return unpaidInvoiceBanner.banner;
    case "loading":
      return null;
    case "dont-show":
      break;
  }

  if (showJoinedForWorkBanner === "show" && joinedForWorkProps !== null) {
    return <JoinedForWorkButNoTeamBanner {...joinedForWorkProps} />;
  }
  if (
    showJoinedForWorkBanner === "dont-show" &&
    showCreateTeamPromptBanner === "show" &&
    createTeamPromptProps !== null
  ) {
    return <CreateTeamPromptBanner {...createTeamPromptProps} />;
  }

  if (
    showJoinedForWorkBanner === "dont-show" &&
    showCreateTeamPromptBanner === "dont-show" &&
    shouldShowSuggestTeamBanner === "show" &&
    suggestTeamProps !== null
  ) {
    return <SuggestTeamBanner {...suggestTeamProps} />;
  }

  return null;
};
